(function() {
  "use strict";
  angular.module("marketPlace.broadstreet", []);
})();
